import constants from 'constants/notifications.js';

const initialState = {
  footer: null,
  snackbar: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case constants.ADD_FOOTER_NOTIFICATION:
      return { ...state, footer: payload };
    case constants.DELETE_FOOTER_NOTIFICATION:
      return { ...state, footer: null };
    case constants.ADD_SNACKBAR_NOTIFICATION:
      return { ...state, snackbar: payload };
    case constants.DELETE_SNACKBAR_NOTIFICATION:
      return { ...state, snackbar: null };
    case constants.ADD_DIALOG_ERROR_NOTIFICATION:
      return { ...state, dialog: payload };
    case constants.DELETE_DIALOG_ERROR_NOTIFICATION:
      return { ...state, dialog: null };
    default:
      return state;
  }
};
